// 利益レポート・仕入先レポート（Stocky parity v2 Step 8）。読み取り専用。
// プランゲートは Pro（`reports`）。
// 🔴 除外件数（未同期の売上・原価未設定）は必ず返る＝画面で「N件を除外」と出す。
//    黙って落とすと合計が実感と合わず、マーチャントは数字ごと信用しなくなる。
import { apiFetch } from "./client";

export interface ProfitRow {
  variant_id: number;
  sku: string | null;
  title: string | null;
  quantity: number;
  revenue: string;
  cost: string;
  profit: string;
  /** 売上0の行は null（0% と書かない）。 */
  margin_pct: string | null;
}

export interface ProfitReport {
  start: string;
  end: string;
  revenue_total: string;
  cost_total: string;
  profit_total: string;
  /** 売上が未同期だったため除外した明細数（再同期で解消する）。 */
  excluded_unsynced_lines: number;
  /** 原価が引けず除外した明細数（原価未設定 / 商品が削除済み）。 */
  excluded_no_cost_lines: number;
  /**
   * 集計対象になった商品数。`rows` は上位 `row_limit` 件で切ってあるので、
   * これより `rows.length` が少なければ表は一部＝画面でそう言う。
   * 🔴 列が無い旧 API へ当たることがある（SPA と backend は別々にデプロイされる）
   *    ＝`undefined` のときは打ち切りを主張しない。
   */
  row_count_total?: number;
  /** サーバが適用した表示上限。 */
  row_limit?: number;
  rows: ProfitRow[];
}

export interface SupplierRow {
  supplier_id: number | null;
  supplier_name: string | null;
  order_count: number;
  ordered_amount: string;
  /** 入荷実績が無ければ null（0日と書かない）。 */
  avg_lead_time_days: number | null;
  /** 予定日つきの実績が無ければ null。0〜1。 */
  on_time_rate: number | null;
}

export interface SupplierReport {
  start: string;
  end: string;
  rows: SupplierRow[];
}

export interface ReportPeriod {
  start: string;
  end: string;
}

function query({ start, end }: ReportPeriod): string {
  return `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`;
}

export function getProfitReport(period: ReportPeriod): Promise<ProfitReport> {
  return apiFetch<ProfitReport>(`/api/reports/profit${query(period)}`);
}

export function getSupplierReport(period: ReportPeriod): Promise<SupplierReport> {
  return apiFetch<SupplierReport>(`/api/reports/suppliers${query(period)}`);
}
